import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	text-align: left;
	margin-bottom: 4px;
`;

const rowBase = `
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 12px;
	border-radius: 6px;
	width: 100%;
	box-sizing: border-box;
`;

export const ActionRow = styled.button`
	${rowBase};
	background: transparent;
	border: none;
	font-family: inherit;
	text-align: left;
	transition: background-color 0.2s ease;
	color: ${(p) => p.theme.gray[1000]};

	&:hover {
		background: ${(p) => p.theme.gray[200]};
	}
`;

export const InputRow = styled.div`
	${rowBase};
`;

export const IconSlot = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: center;
	width: 20px;
	padding-top: 2px;
	flex-shrink: 0;
	color: ${(p) => p.theme.gray[1000]};
`;

export const TextBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	flex: 1;
	min-width: 0;
`;

export const Title = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: ${(p) => p.theme.gray[1000]};
`;

export const Description = styled.div`
	font-size: 12px;
	color: ${(p) => p.theme.gray[700]};
	line-height: 1.4;
`;

export const UrlField = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	flex: 1;
	min-width: 0;
	margin-top: 2px;
`;

export const UrlInput = styled.input`
	flex: 1;
	min-width: 0;
	background: ${(p) => p.theme.gray[0]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 6px;
	padding: 7px 10px;
	font-size: 13px;
	color: ${(p) => p.theme.gray[1000]};
	font-family: inherit;

	&:focus {
		outline: none;
		border-color: ${(p) => p.theme.blue[400]};
	}

	&::placeholder {
		color: ${(p) => p.theme.gray[600]};
	}
`;

export const GoButton = styled.button`
	background: ${(p) => p.theme.blue[400]};
	color: #ffffff;
	border: none;
	border-radius: 6px;
	padding: 7px 14px;
	font-size: 13px;
	font-weight: 500;
	font-family: inherit;
	flex-shrink: 0;
	transition: background-color 0.2s ease;

	&:hover:not(:disabled) {
		background: ${(p) => p.theme.blue[500]};
	}

	&:disabled {
		opacity: 0.5;
	}
`;

export const Chevron = styled.div`
	color: ${(p) => p.theme.gray[600]};
	flex-shrink: 0;
	display: flex;
	align-items: center;
`;
